import _regeneratorRuntime from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { BaseSource } from './basesource';

var FileReaderSource =
/*#__PURE__*/
function (_BaseSource) {
  _inherits(FileReaderSource, _BaseSource);

  function FileReaderSource(file) {
    var _this;

    _classCallCheck(this, FileReaderSource);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileReaderSource).call(this));
    _this.file = file;
    return _this;
  }

  _createClass(FileReaderSource, [{
    key: "fetchSlice",
    value: function () {
      var _fetchSlice = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(slice, signal) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  var blob = _this2.file.slice(slice.offset, slice.offset + slice.length);

                  var reader = new FileReader();

                  reader.onload = function (event) {
                    return resolve(event.target.result);
                  };

                  reader.onerror = reject;
                  reader.onabort = reject;
                  reader.readAsArrayBuffer(blob);

                  if (signal) {
                    signal.addEventListener('abort', function () {
                      return reader.abort();
                    });
                  }
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fetchSlice(_x, _x2) {
        return _fetchSlice.apply(this, arguments);
      }

      return fetchSlice;
    }()
  }]);

  return FileReaderSource;
}(BaseSource);
/**
 * Create a new source from a given file/blob.
 * @param {Blob} file The file or blob to read from.
 * @returns The constructed source
 */


export function makeFileReaderSource(file) {
  return new FileReaderSource(file);
}